export const placeData = {
	title: "Contract Information",
	description: "General account information",
	loading: "Loading...",
	accessDenied: {
		title: "Access Denied",
		description: "You do not have permission to access this screen.",
	},
	error: {
		title: "Error",
		description: "An error occurred while loading the data. Please try again.",
	},
	sections: {
		general: {
			title: "General",
			description: "General account information",
		},
		fees: {
			title: "Fees",
			description: "Values represent the fee that will be applied to the items below",
		},
		balanceModel: {
			title: "Balance model",
			description: "Balance return definition",
		},
		grabAndGo: {
			title: "Grab and Go",
			description: "Configured delivery type",
		},
		eventCurrency: {
			title: "Event currency",
			description: "Currency and proportion used",
		},
		smartPosSettings: {
			title: "SmartPOS settings",
			description: "Integration data",
		},
		communication: {
			title: "Communication",
			description: "Sending messages (SMS and WhatsApp)",
		},
		charges: {
			title: "Charges",
			description: "Products and equipment acquired",
		},
	},
	fields: {
		contractNumber: "Contract number",
		profile: "Profile",
		mainVersion: "Main version",
		guaranteedMonthlyMinimum: "Guaranteed monthly minimum",
		monthlyBillingCap: "Monthly billing cap",
		zigResponsible: "ZIG Responsible",
		placeStatus: "Place status",
		ppuAuthorizationValue: "App pre-authorization amount",
		zigLocation: "Zig Location",
		rechargeNotIntegratedLimit: "Non-integrated recharge limit",
		localResponsible: "Local responsible(s)",
		minVersion: "Minimum PDV version",
		status: {
			active: "Active",
			blocked: "Blocked",
			inactive: "Inactive",
			paused: "Paused",
		},
		profileValues: {
			barAndRestaurant: "Bar and Restaurant",
			restaurant: "Restaurant",
			concertHall: "Concert Hall",
			bar: "Bar",
			nightclub: "Nightclub",
			park: "Park",
			sportsArena: "Sports Arena",
			other: "Other",
		},
		house: "House",
		nonIntegratedPaymentLimit: "Non-integrated payment limit per device and event",
		placeClassification: "Place classification",
		smsNumbers: "Numbers for sending revenue SMS",
		serviceFee: "Service fee",
		deliveryFee: "Delivery fee",
		onlineDeliveryFee: "Online delivery fee",
		advanceReservationFee: "Advance reservation fee",
		processingFee: "Processing fee",
		platformFee: "Platform fee",
		balanceReturnType: "Balance return type",
		parentPlaceName: "Parent Place",
		returnPeriod: "Return period",
		minimumBalance: "Minimum balance",
		maximumBalance: "Maximum balance",
		deliveryType: "Delivery type",
		deliveryTime: "Delivery time",
		deliveryRadius: "Delivery radius",
		deliveryTypes: {
			counterDelivery: "Counter delivery",
			tableDelivery: "Table delivery",
		},
		deliveryPlatforms: {
			ifood: {
				brandName: "IFood",
				settlementDays: "Days until IFood settlement",
				fee: "iFood fee",
				description: "IFood  Settings",
			},
		},
		currency: "Name",
		exchangeRate: "Proportion to the country's currency",
		currencySymbol: "Symbol",
		decimalPlaces: "Decimal places",
		integrationStatus: "Integration status",
		apiVersion: "API version",
		lastSync: "Last sync",
		syncFrequency: "Sync frequency",
		smsCost: "Cost of sending",
		whatsappCost: "Cost of sending",
		whatsappNumber: "Number",
		whatsappId: "Service ID",
		pushNotifications: "Push notifications",
		placeType: "Place Type",
		placeTypesValues: {
			default: "Default",
			delivery: "Delivery",
			transfers: "Transfers",
			advance: "Advance",
			billing: "Billing",
		},
		zigFeeShouldBeChargedInDebit: "Charge Zig fee on debit date",
		hasCustomizedCard: "Security deposit belongs to the customer",
		user: "User",
		fiscalPrinters: "Fiscal printers",
		name: "Printers",
		bankAccountData: "Bank account data",
		receivingAccount: "Receiving account",
		accountHolder: "Account holder",
		documentType: "Document type",
		digit: "Digit",
		accountIdentification: "Account identification",
		accountIdentifier: "Account identifier",
		cpfCnpj: "CPF/CNPJ",
		accountType: "Account type",
		accountTypes: {
			conta_corrente: "Checking",
			conta_poupanca: "Savings",
			conta_salario: "Salary",
		},
		registrationData: "Data to register",
		bankData: "Bank data",
		branch: "Branch",
		bank: "Bank",
		bankName: "Bank name",
		account: "Account",
		recharges: "Recharges",
		rechargeValidityCriteria: "Validity and recharge criteria",
		rechargesExpireIn: "Recharges expire in",
		remainingRechargeActions: "Actions for remaining recharge",
		delveryOnlineRules: "Online delivery rules",
		chargeBack: "Expire at the end of the event",
		placeOnly: "Managed by the house",
		normal: "Managed by Zig",
		// Rates and values
		rateType: "Type",
		rateTypeLabel: "Rate type",
		singleRate: "Single rate",
		segmentedFeeType: "Segmented fee",
		singleFeeType: "Single fee",
		systemFee: "System fee",
		inHouseConsumption: "In-house consumption",
		ticketOfficeRevenue: "Ticket office revenue",
		rechargeSurplus: "Recharge surplus",
		bonus: "Bonus",
		fixedFee: "Fixed fee",
		appFee: "App fee",
		prechargeOnlinePaymentFee: "Pre-charge/online payment fee",
		fixedFeePaymentDay: "Fixed fee payment day",
		anticipationFee: "Anticipation fee",
		thirdPartyPaymentFee: "Third-party payment fee",
		// Payment with ZigPay machine
		zigPayMachinePayment: "Payment with ZigPay machine",
		debit: "Debit",
		credit: "Credit",
		creditOtherFlags: "Credit (Other flags)",
		debitOtherFlags: "Debit (Other flags)",
		replicateRatesForAllFlags: "Replicate rates for all flags?",
		pix: "Pix",
		pixKey: "Pix Key",
		pixKeyType: "Pix Key Type",
		yes: "Yes",
		// Food voucher
		foodVoucher: "Food voucher",
		// Payment with machine integrated into client's EC
		integratedMachinePayment: "Payment with machine integrated into client's EC",
		machineCommission: "Machine commission",
		anticipatedConsumption: "Anticipated consumption",
		anticipatedBar: "Anticipated/Bar",
		ticketOffice: "Ticket office",
		// Days until collection
		daysUntilCollection: "Days until collection",
		daysUntilCollectionDescription:
			"Number of days to exercise collection and payments in the following formats",
		collectionDaysDescription:
			"Number of days to exercise collection and payments in the following formats",
		// Installments
		installment: "Installments",
		installmentFee: "Installment fee",
		maxInstallments: "Max number of installments",
		notApplicable: "Not applicable",
		// Charges
		chargeTitle: "Title",
		chargeCategory: "Category",
		chargeRecurrence: "Recurrence",
		chargeStartDate: "Start",
		chargeEndDate: "End",
		chargeInstallmentValue: "Installment value",
		installmentRate: "Installment rate",
		maxInstallmentsNumber: "Max number of installments",
		// Adjustment categories
		adjustmentCategories: {
			anticipationFee: "Anticipation Fee",
			balanceAdjustment: "Balance Adjustment",
			bonifications: "Other Bonuses",
			cardActivations: "Activation Fee",
			equipmentsMaintenance: "Equipment Maintenance",
			equipmentsPurchase: "Equipment Purchase",
			equipmentsRental: "Equipment Rental",
			expiredRecharges: "Expired Recharges",
			generalZigMachineTax: "Acquirer Fees on Integrated Machines",
			generalZigMachineTPV: "Billing via Integrated ZIG Acquirer",
			genericOperationsFee: "General Operating Expenses",
			genericServices: "Other Services and Charges",
			notUsedRecharges: "Unused Recharges",
			operatorFee: "Operator Daily Rate",
			payments: "Payments",
			paymentsTax: "Supplier Payment Fee",
			pos: "Billing on Non-Integrated Machines (POS)",
			posTax: "Acquirer Fee on Non-Integrated Machines (POS)",
			reimbursements: "Customer Refunds",
			systemSetup: "System Setup",
			totemFee: "Totem Fee",
			wifiAssistance: "Wifi Technical Assistance",
			wifiSetup: "Wifi Setup",
			withdraw: "Withdrawals",
			zigDevicePurchase: "Purchase of Command Devices",
			zigFee: "Zig Fee",
			totenRental: "Totem Rental",
			others: "Others",
			renegotiation: "Renegotiation",
			advance: "Advance",
			advanceFee: "Advance Fee",
			balanceRetention: "Balance Retention",
			balanceTransfer: "Transfer Between Places",
			residueRemain: "Residue Retention",
			missingCards: "Missing Cards",
			billingInvoice: "Invoice Charge",
			guaranteedMinimumSupplement: "Guaranteed Minimum Supplement",
			commandFiscalPurchase: "Fiscal Command Purchase",
			accountsReceivableLegal: "AR - Legal",
			cardDiscount: "Card Discount",
			discountGeneralOperatingExpenses: "Discount General Operating Expenses",
			discountOperatorDailyRate: "Discount Operator Daily Rate",
			generalDiscount: "General Discount",
			dailyCoordinatorRate: "Coordinator Daily Rates",
			dailyHeadsRate: "Heads Daily Rates",
			setupDailyCoordinatorRate: "Setup Coordinator Daily Rates",
			setupDailyHeadsRate: "Setup Heads Daily Rates",
			setupDailySupervisorsRate: "Setup Supervisor Daily Rates",
			setupDailyTechnicalRate: "Setup Technical Daily Rates",
			setupDailyTraineeRate: "Setup Trainee Daily Rates",
			dailySupervisorRate: "Supervisor Daily Rates",
			dailyTechnicianRate: "Technician Daily Rates",
			dailyTraineeRate: "Trainee Daily Rates",
			damagedEquipment: "Damaged Equipment",
			integratedAPPBilling: "Integrated App Billing",
			apartCreditBilling: "Separate Credit Billing",
			integratedCreditBilling: "Integrated Credit Billing",
			apartDebitBilling: "Separate Debit Billing",
			integratedDebitBilling: "Integrated Debit Billing",
			apartBillingPIX: "Separate PIX Billing",
			integratedPIXBilling: "Integrated PIX Billing",
			integratedAdvancedRechargeBilling: "Integrated Advanced Recharge Billing",
			interestandPenalties: "Interest and Penalties",
			softwareLicense: "Software License",
			replacedMachines: "Replaced Machines",
			minimumGuaranteedpermachine: "Minimum Guaranteed per Machine",
			otherEquipment: "Other Equipment",
			rebate: "Rebate",
			setupAdvancedRecharge: "Advanced Recharge Setup",
			setupRefundSite: "Refund Site Setup",
			acquirementfeeforIntegratedZIGApplication:
				"Acquirer Fee on Integrated ZIG Application",
			acquiringfeeonapartCredit: "Acquirer Fee on Separate Credit",
			acquiringfeeforIntegratedCredit: "Acquirer Fee on Integrated Credit",
			acquiringfeeforapartDebit: "Acquirer Fee on Separate Debit",
			acquiringfeeonIntegratedDebit: "Acquirer Fee on Integrated Debit",
			acquiringfeeforapartPIX: "Acquirer Fee on Separate PIX",
			acquiringfeeforIntegratedPIX: "Acquirer Fee on Integrated PIX",
			acquiringfeeforAdvancedRecharge: "Acquirer Fee on Advanced Recharge",
			refundfee: "Refund Fee",
			relatedpartyretentionfee: "Related Party Retention Fee",
			rappiFee: "Rappi Fee",
			SMSFee: "SMS Fee",
			residualFee: "Residual Fee",
			cardtoCashExchange: "Card to Cash Exchange",
			cardtoProductExchange: "Card to Product Exchange",
			travelFood: "Travel Food",
			shipping: "Shipping",
			accommodation: "Accommodation",
			transport: "Transport",
			pixRefundFee: "PIX Refund Fee",
			softwareLicenseMachine: "Machine Software License",
			softwareLicenseTotem: "Totem Software License",
			integratedAdvanceDebitBilling: "Integrated Advance Debit Billing",
			integratedAdvanceCreditBilling: "Integrated Advance Credit Billing",
			integratedAdvancePixBilling: "Integrated Advance PIX Billing",
			integratedAdvanceDebitFee: "Integrated Advance Debit Fee",
			integratedAdvanceCreditFee: "Integrated Advance Credit Fee",
			integratedAdvancePixFee: "Integrated Advance PIX Fee",
			integratedOnlineDeliveryIncome: "Integrated Online Delivery Income",
			zeDeliveryDiscount: "Zé Delivery Discount",
			ticketPrinting: "Ticket Printing",
			validatorRental: "Validator License",
			zeDeliveryRetention: "Zé Delivery Retention",
			valueAddedTax: "VAT",
			moneyTPV: "Cash TPV",
			acquiringFeeForIntegratedInstallmentCredit:
				"Acquirer Fee on Integrated Installment Credit",
			issuedCharge: "Issued Charge",
			softwareLicenseGiftback: "Giftback Software License",
			loanBracelet: "Bracelet Loan",
			lendingCards: "Card Loan",
			externalResourceContribution: "External Resource Contribution",
			anticipationValue: "Anticipation Value",
			anticipatedValue: "Anticipated Value",
			generalZigMachineCreditIn2Installments: "TPV Credit Installment 2X",
			generalZigMachineCreditIn3Installments: "TPV Credit Installment 3X",
			generalZigMachineCreditIn4Installments: "TPV Credit Installment 4X",
			generalZigMachineCreditIn5Installments: "TPV Credit Installment 5X",
			generalZigMachineCreditIn6Installments: "TPV Credit Installment 6X",
			generalZigMachineCreditIn7Installments: "TPV Credit Installment 7X",
			generalZigMachineCreditIn8Installments: "TPV Credit Installment 8X",
			generalZigMachineCreditIn9Installments: "TPV Credit Installment 9X",
			generalZigMachineCreditIn10Installments: "TPV Credit Installment 10X",
			generalZigMachineCreditIn11Installments: "TPV Credit Installment 11X",
			generalZigMachineCreditIn12Installments: "TPV Credit Installment 12X",
			generalZigMachineCreditIn2InstallmentsFEE: "Credit Installment Fee 2X",
			generalZigMachineCreditIn3InstallmentsFEE: "Credit Installment Fee 3X",
			generalZigMachineCreditIn4InstallmentsFEE: "Credit Installment Fee 4X",
			generalZigMachineCreditIn5InstallmentsFEE: "Credit Installment Fee 5X",
			generalZigMachineCreditIn6InstallmentsFEE: "Credit Installment Fee 6X",
			generalZigMachineCreditIn7InstallmentsFEE: "Credit Installment Fee 7X",
			generalZigMachineCreditIn8InstallmentsFEE: "Credit Installment Fee 8X",
			generalZigMachineCreditIn9InstallmentsFEE: "Credit Installment Fee 9X",
			generalZigMachineCreditIn10InstallmentsFEE: "Credit Installment Fee 10X",
			generalZigMachineCreditIn11InstallmentsFEE: "Credit Installment Fee 11X",
			generalZigMachineCreditIn12InstallmentsFEE: "Credit Installment Fee 12X",
			totalTpvBarIncome: "Bar Receipt Fee",
			totalTpvEntranceIncome: "Ticket Office Receipt Fee",
			totalTpvEntranceIncomeConsumption: "Ticket Office Consumption Receipt Fee",
			totalTpvBarMinimumConsumption: "Bar Minimum Receipt Fee",
			totalTpvBonus: "Bonus Receipt Fee",
			advanceRenegotiation: "Advance Renegotiation",
			zigTicketsRetention: "Zig Tickets Retention",
			onlineDeliveryAcquisitionFee: "Online Delivery Acquisition Fee",
			bankRefund: "Bank Refund",
			acquirerRefund: "Acquirer Refund",
			pixPreventiveBlock: "PIX - Preventive Block",
			pixAuthorizedUnblock: "PIX - Authorized Unblock",
			pixRefundByChargeback: "PIX - Refund by Chargeback",
			RelatedStakeholderRetentionReprocessing: "Retention and Reprocessing",
			cleaning: "Cleaning",
			electrical: "Electrical",
			hydraulics: "Hydraulics",
			supply: "Supply",
		},
		// Recurrences
		adjustmentRecurrences: {
			daily: "Daily",
			event: "Per event",
			monthly: "Monthly",
			weekly: "Weekly",
		},
	},
};
